import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../services/axiosInstance";
import { API_ENDPOINTS } from "../services/api/apiConfig";
import { useUserProfile } from "./useUserProfile";

export interface DoctorStats {
    todayConsultations: number;
    totalPatients: number;
    upcomingAppointments: number;
    pendingExams: number;
    myPendingConstantes: number;
}

export const useDoctorStats = () => {
    const { userData } = useUserProfile();
    const doctorId = userData?.id;

    return useQuery<DoctorStats>({
        queryKey: ['doctor', 'stats', doctorId],
        queryFn: async () => {
            if (!doctorId) throw new Error("Doctor ID is required");

            const [
                allTimeStats,
                todayStats,
                appointments,
            ] = await Promise.all([
                axiosInstance.get(API_ENDPOINTS.CONSTANTES.BY_DOCTOR(doctorId, '?todayOnly=false&showConsulted=false&size=1')).then(res => res.data),
                axiosInstance.get(API_ENDPOINTS.CONSTANTES.BY_DOCTOR(doctorId, '?todayOnly=true&showConsulted=true&size=1')).then(res => res.data),
                axiosInstance.get(API_ENDPOINTS.APPOINTMENTS.MINE).then(res => res.data),
            ]);

            const allTimeMeta = allTimeStats.metadata || {};
            const todayMeta = todayStats.metadata || {};

            const upcoming = (appointments || []).filter((a: any) => {
                const date = new Date(a.date || a.appointmentDate || a.startTime);
                const now = new Date();
                const tomorrow = new Date(now);
                tomorrow.setDate(tomorrow.getDate() + 1);
                return date >= now && date <= tomorrow;
            }).length;

            return {
                todayConsultations: todayMeta.consultedCount || 0,
                totalPatients: allTimeMeta.uniquePatientCount || 0,
                upcomingAppointments: upcoming,
                pendingExams: allTimeMeta.pendingCount || 0,
                myPendingConstantes: allTimeMeta.pendingCount || 0,
            };
        },
        enabled: !!doctorId,
        refetchInterval: 30000,
    });
};
